(function ($)
{
    var mJobBoardSearchObjectCounter = 0;

    $.widget("ui.JobBoardSearch",
        {
            options:
            {
                PageContentId: null,
                InitialPagerData: null,
                JobBoardResultSelector: '.jobboard_list_result.jobboard',
                ResultListSelector: '.jobboard_list',
                JobBoardGallerySelector: '.jobboard_search_results',
                LinkedJobBoardClass: 'fbcms_linkedjobboard',
                SharePanelSelector: '.vp_share_panel'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _MyObjectNumber: null,

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);

                if (self.options.PageContentId === null)
                {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedJobBoardClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.JobBoardGallerySelector))
                {
                    FBUtilities.LogMessage('JobBoardList - required settings null or empty.');
                    return;
                }

                mJobBoardSearchObjectCounter = mJobBoardSearchObjectCounter += 1;
                self._MyObjectNumber = mJobBoardSearchObjectCounter;

                const jobBoardSearchResultId = 'JobBoardSearchResult' + self._MyObjectNumber;

                const jResultsContainer = jElement.find(self.options.ResultListSelector);
                jResultsContainer.attr('role', 'region');
                jResultsContainer.attr('aria-live', 'polite');
                jResultsContainer.attr('id', jobBoardSearchResultId);

                self.SetupJobBoardButtons();
                self.SetupPagination();

                const jSearchButton = jElement.find('.search_button');
                jSearchButton.on('click', function (aEvent)
                {
                    aEvent.preventDefault();
                    self.Search();
                    return false;
                });
                jSearchButton.attr('aria-controls', jobBoardSearchResultId);

                const jResetButton = jElement.find('.reset_button');
                jResetButton.on('click', function (aEvent)
                {
                    aEvent.preventDefault();
                    self.Reset();
                    return false;
                });
                jResetButton.attr('aria-controls', jobBoardSearchResultId);

                const filterSearchText = jElement.find('input[name="SearchText"]');
                filterSearchText.attr('aria-controls', jobBoardSearchResultId);
                filterSearchText.on(
                    'keypress',
                    function (aEvent)
                    {
                        if (aEvent.key === "Enter")
                        {
                            aEvent.preventDefault();
                            self.Search();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

                const jFilterStartDate = jElement.find('input[name="SearchDateRangeStart"]');
                const jFilterEndDate = jElement.find('input[name="SearchDateRangeEnd"]');

                if (jFilterStartDate.length === 1 && jFilterEndDate.length === 1)
                {
                    const checkDatePickers = function (aStartModified)
                    {
                        const startText = jFilterStartDate.val();
                        const endText = jFilterEndDate.val();
                        if (startText.length !== 0 && endText.length !== 0)
                        {
                            const startDate = new Date(startText);
                            const endDate = new Date(endText);

                            if (startDate > endDate)
                            {
                                if (aStartModified === true)
                                {
                                    jFilterEndDate.val(startText);
                                }
                                else
                                {
                                    jFilterStartDate.val(endText);
                                }
                            }
                        }
                    };

                    jFilterStartDate.FBDateSelector({
                        ClearInputButtonLabel: 'Clear Start Date'
                        , OnChangeCallback: function (aEvent) {checkDatePickers(true);}
                    });
                    jFilterEndDate.FBDateSelector({
                        ClearInputButtonLabel: 'Clear End Date'
                        , OnChangeCallback: function (aEvent) {checkDatePickers(false);}
                    });

                    jFilterStartDate.attr('aria-controls', jobBoardSearchResultId);
                    jFilterEndDate.attr('aria-controls', jobBoardSearchResultId);

                    jFilterStartDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                    jFilterEndDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                }

                $.each(
                    jElement.find('.category'),
                    function (aIndex, aValue)
                    {
                        $(aValue).TagCategorySearchFilter(
                            {
                                CategoryNameSelector: '.category_topper'
                                , ItemContainerSelector: '.items'
                                , FilterControlsElementId: jobBoardSearchResultId
                            });
                    }
                );

                //self.Reset();
            },

            Reset: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.jobboard_search_form');

                // reset all input fields.
            jFormDiv.find('input[name="SearchText"]').val('');
            jFormDiv.find('input[name="SearchDateRangeStart"]').val('');
            jFormDiv.find('input[name="SearchDateRangeEnd"]').val('');
                $.each(
                    jElement.find('.category'),
                    function (aIndex, aValue)
                    {
                        $(aValue).TagCategorySearchFilter('Reset');
                    }
                );

            jElement.find('.jobboard_search_form').find('input[name="IsReset"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            GetSearchData: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.jobboard_search_form');
                const searchData = {
                    "PageContentId": self.options.PageContentId,
                "FromJobBoardSearchForm": jFormDiv.find('input[name="IsNewSearch"]').val(),
                "ResetJobBoardSearchForm": jFormDiv.find('input[name="IsReset"]').val(),
                "SearchText": jFormDiv.find('input[name="SearchText"]').val(),
                "SearchDateRangeStart": jFormDiv.find('input[name="SearchDateRangeStart"]').val(),
                "SearchDateRangeEnd": jFormDiv.find('input[name="SearchDateRangeEnd]"').val(),
                    "SelectedItems": jFormDiv.find('input[name=SelectedItems]:checked')
                        .map(function () {return $(this).val();})
                        .get().join(',')
                };

            jFormDiv.find('input[name="IsNewSearch"]').val('');
            jFormDiv.find('input[name="IsReset"]').val('');

                return searchData;
            },

            Search: function ()
            {
                const self = this;
                const jElement = $(self.element);

            jElement.find('.jobboard_search_form').find('input[name="IsNewSearch"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            SetupPagination: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jobBoardSearchResultId = 'JobBoardSearchResult' + self._MyObjectNumber;
                const jJobBoardGallery = jElement.find(self.options.JobBoardGallerySelector);
                const jMoreContainer = jJobBoardGallery;

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/JobBoards/Search/${self.options.PageContentId}/`,
                        LoadingTitle: "Search",
                        NormalContainer: jJobBoardGallery,
                        MoreContainer: jMoreContainer,
                        OnSuccess: function (mode, data, textStatus, jqXHR)
                        {
                            self.SetupJobBoardButtons();
                        },
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function ()
                        {
                            return self.GetSearchData();
                        },
                        LiveRegionId: jobBoardSearchResultId
                    });
            },

            SetupJobBoardButtons: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jGallery = jElement.find(self.options.JobBoardGallerySelector);
                const jContainer = jElement.find(self.options.ResultListSelector);
                const jJobBoards = jContainer.find(self.options.JobBoardResultSelector);
                jJobBoards.addClass(self.options.LinkedJobBoardClass);
                const jControlledJobBoardBlock = $('.fbcms_jobboard_block');

                $.each(
                    jJobBoards,
                    function (aIndex, aValue)
                    {
                        const jJobBoard = $(aValue);
                        const jobBoardId = jJobBoard.find('[data-jobboard-id]').data('jobboard-id');
                        const jExtendedElement = jJobBoard.find('.extended_details');
                        jExtendedElement.attr('id', 'jobboard_details_' + jobBoardId);
                        jExtendedElement.before('<a href="#" class="details_button details_closed">More Details <span class="visually-hidden">for ' + jJobBoard.data("jobboard-title") + "<span></a>");
                        const extendedButton = jJobBoard.find('.details_button');
                        extendedButton.attr('aria-controls', 'jobboard_details_' + jobBoardId);
                        if (jExtendedElement.length > 0)
                        {
                            jExtendedElement.attr('id', 'jobboard_details_' + jobBoardId);
                            jExtendedElement.attr('role', 'region');
                            jExtendedElement.attr('tabindex', '-1');
                            jExtendedElement.attr('aria-expanded', 'false');
                            jExtendedElement.addClass('details_closed');
                            jExtendedElement.slideUp();
                        }
                    }
                );

                jGallery
                    .off('click', self.options.JobBoardResultSelector + ' .details_button')
                    .off('click', self.options.JobBoardResultSelector)
                    .off('keydown', self.options.JobBoardResultSelector)
                    .on('click', self.options.JobBoardResultSelector + ' .details_button', handleDetailsClick)
                    .on('click', self.options.JobBoardResultSelector, handleJobBoardClick)
                    .on('keydown', self.options.JobBoardResultSelector, handleKeyDown);

                function handleKeyDown(aEvent)
                {
                    const code = aEvent.which;
                    // 13 = Return, 32 = Space
                    if (code === 13 || code === 32)
                    {
                        $(this).click();
                    }
                }

                function handleJobBoardClick(aEvent)
                {
                    const jElement = $(aEvent.target);
                    const jJobBoard = jElement.closest(self.options.JobBoardResultSelector);

                    if (jElement.closest('.details_button').length > 0)
                    {
                        return true;
                    }
                    if (jElement.closest('.extended_details').length > 0)
                    {
                        return true;
                    }

                    if (jElement.closest(self.options.SharePanelSelector).length > 0)
                    {
                        return true;
                    }

                    aEvent.preventDefault();
                    const jLinkElement = jJobBoard.find('[data-jobboard-id]');
                    const jobBoardId = jLinkElement.data('jobboard-id');
                    if (FBUtilities.IsParameterUndefinedOrNull(jobBoardId))
                    {
                        return false;
                    }

                    const url = jLinkElement.data('href');
                    if (FBUtilities.IsParameterUndefinedOrNull(url))
                    {
                        if (jControlledJobBoardBlock.length > 0)
                        {
                            jControlledJobBoardBlock.JobBoardBlock('LoadJobBoard', jobBoardId, {}, 2000 /* transition speed */);
                        }
                    }
                    else
                    {
                        window.location = url;
                    }
                    return false;
                }

                function handleDetailsClick(aEvent)
                {
                    aEvent.preventDefault();
                    const jElement = $(aEvent.target);
                    const jJobBoard = jElement.closest(self.options.JobBoardResultSelector);
                    const jExtendedElement = jJobBoard.find('.extended_details');
                    const jExtendedButton = jJobBoard.find('.details_button');

                    if (jExtendedElement.hasClass('details_closed'))
                    {
                        jExtendedElement.removeClass('details_closed');
                        jExtendedButton.removeClass('details_closed');
                        jExtendedButton.html('Less Details <span class="visually-hidden">for ' + jJobBoard.data("jobboard-title") + "<span>");
                        jExtendedElement.slideDown();
                        jExtendedElement.attr('aria-expanded', 'true');
                        jExtendedElement.focus();
                    }
                    else
                    {
                        jExtendedElement.addClass('details_closed');
                        jExtendedButton.addClass('details_closed');
                        jExtendedButton.html('More Details <span class="visually-hidden">for ' + jJobBoard.data("jobboard-title") + "<span>");
                        jExtendedElement.slideUp();
                        jExtendedElement.attr('aria-expanded', 'false');
                    }
                    return false;
                }
            }
        });
})(jQuery);
